import { z } from 'zod/v4';

const redirectUriSchema = z
  .string()
  .url()
  .refine(
    (uri) => {
      const url = new URL(uri);
      const isLoopback =
        url.hostname === 'localhost' ||
        url.hostname === '127.0.0.1' ||
        url.hostname === '[::1]';
      return url.protocol === 'https:' || isLoopback;
    },
    {
      message:
        'redirect_uri must use https, or http with a loopback host (localhost / 127.0.0.1 / [::1])',
    },
  );

export const createOAuthClientSchema = z.object({
  name: z.string().min(1).max(255),
  redirectUris: z.array(redirectUriSchema).min(1).max(20),
});

export type CreateOAuthClientInput = z.infer<typeof createOAuthClientSchema>;
